import BreakPoints from '../design-utils/breakpoints';

export default BreakPoints;
